<template>
    <div class="agenda-rows-table">
        <div class="th"><input type="checkbox" v-model="selectAll"></div>
        <div class="th">ID</div>
        <div class="th">Start date/time</div>
        <div class="th">End date/time</div>
        <div class="th">Session name</div>
        <div class="th">Location</div>
        <div class="th">Speaker</div>
        <div class="th">Tags</div>
        <div class="th actions">Actions</div>
        <template
            v-for="agenda in localAgendas"
        >
            <div class="td" :key="agenda.agn_id">
                <input type="checkbox" v-model="agenda.selected">
            </div>
            <div class="td" :key="'agn_id' + agenda.agn_id">
                {{ agenda.agn_id }}
            </div>
            <div class="td" :key="'agn_from' + agenda.agn_id">
                {{ agenda.agn_from }}
            </div>
            <div class="td" :key="'agn_to' + agenda.agn_id">
                {{ agenda.agn_to }}
            </div>
            <div class="td" :key="'agn_name' + agenda.agn_id">
                {{ agenda.agn_name }}
            </div>
            <div class="td" :key="'loc_name' + agenda.agn_id">
                {{ agenda.loc_name }}
            </div>
            <div class="td" :key="'speaker_id' + agenda.agn_id">
                {{ getSpeakerName(agenda) }}
            </div>
            <div class="td" :key="'tags' + agenda.agn_id">
                <span 
                    v-for="(tag, index) in agenda.tags"
                    :key="index"
                    class="tag"
                >
                    {{ tag }}
                </span>
            </div>
            <div class="td buttons" :key="'action' + agenda.agn_id">
                <a-button
                    class="btn clone"
                    icon="copy"
                    @click="$emit('clone-agenda', agenda)"
                >Clone</a-button>
                <a-button 
                    class="btn edit"
                    icon="edit"
                    @click="$emit('set-current-agenda', agenda)"
                >Quick Edit</a-button>
                <a-button 
                    class="btn delete"
                    icon="delete"
                    @click="$emit('confirm-delete', agenda.agn_id)"
                >Delete</a-button>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        agendas: {
            type: Array,
            required: true,
        },
    },
    data () {
        return {
            localAgendas: [],
            selectAll: false,
        };
    },
    computed: {
        selectedAgendas () {
            return this.localAgendas.filter(el => el.selected);
        },
    },
    watch: {
        agendas: {
            handler () {
                this.init();
            },
        },
        selectAll: {
            handler (isChecked) {
                for (const el of this.localAgendas) {
                    el.selected = isChecked;
                }
            },
        },
        selectedAgendas: {
            deep: true,
            handler () {
                this.$emit('set-selected-agendas', this.selectedAgendas);
            },
        },
    },
    mounted () {
        this.init();
    },
    methods: {
        init () {
            this.localAgendas = JSON.parse(JSON.stringify(this.agendas)).map(el => {
                if (el.tags) el.tags = el.tags.split(',');
                return el;
            });
        },
        getSpeakerName ({ usr_firstname, usr_lastname }) {
            return usr_firstname && usr_lastname? `${usr_firstname} ${usr_lastname}` : '/';
        }
    },
};
</script>

<style lang="scss" scoped>
.agenda-rows-table {
    display: grid;
    grid-template-columns: .2fr .3fr 1fr 1fr 1fr 1fr .3fr 1.5fr 2.2fr;
    border: 1px solid #DFE1E6;
    border-radius: 2px;
    .th, .td {
        min-height: 54px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #DFE1E6;
        color: #262626;
        // &:nth-last-child(9) {
        //     border: none;
        // }
    }
    .th {
        background: #F4F5F7;
        font-weight: 600;
        &.actions {
            display: flex;
            justify-content: flex-end   ;
        }
    }
    .td {
        &.buttons {
            justify-content: flex-end;
        }
    }
    .tag {
        border: 1px solid #DFE1E6;
        color: #B2BAC7;
        border-radius: 2px;
        margin: 0 3px;
        padding: 2px 6px;
    }
    .btn {
        color: #FFF;
        margin: 0 10px;
        &:first-child {
            margin-left: 0;
        }
        &:last-child {
            margin-right: 0;
        }
    }
    .clone {
        background-color: #B2BAC7;
        width: 90px;
    }
    .edit {
        width: 120px;
        background-color: #2295D6;
    }
    .delete {
        width: 100px;
        background-color: #D23214;
    }
}
</style>